export const timestampToDate = (timestamp) => Number(timestamp) * 1000
